App = App || {};

App.ItemImport = (function ($, Vue) {
	"use strict";

	var $modal;

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("item-import-app");

		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		new Vue({
			el: rootElement,
			data: {
				isSubmitting: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: [],
				uploadPhase: "Idle",
				uploadProgress: 0,
				currentJobId: null, 
				statusTimerId: null,
				activeRequest: null,
				isCanceling: false,
				model: { file: null }
			},

			computed: {
				phaseLabel: function () {
					if (this.uploadPhase === "Upload")
						return "Uploading";

					return String(this.uploadPhase);
				},
				progressBarClasses: function () {
					if (this.uploadPhase === "Failed")
						return "bg-danger";
					if (this.uploadPhase === "Completed" || this.uploadPhase === "Idle")
						return "";

					if (this.uploadPhase === "Committing")
						return "progress-bar progress-bar-animated";

					return "progress-bar-striped progress-bar-animated";
				}
			},

			methods: {
				onFileChange: function (event) {
					var input = event && event.target ? event.target : this.$refs.fileInput;
					var selectedFile = (input && input.files && input.files[0]) ? input.files[0] : null;
					this.model.file = selectedFile;
					this.setFileValidity();
				},

				setFileValidity: function () {
					var input = this.$refs.fileInput;
					if (!input || !input.setCustomValidity) return;

					var isCsv = false;
					if (this.model.file) {
						var name = (this.model.file.name || "").toLowerCase();
						var type = (this.model.file.type || "").toLowerCase();
						isCsv = name.endsWith(".csv") || type.indexOf("csv") !== -1;
					}
					input.setCustomValidity(this.model.file && isCsv ? "" : "Please choose a valid .csv file.");
				},

				clearState: function () {
					this.isSubmitting = false;
					this.isComplete = false;
					this.alertMessage = "";
					this.alertErrors = [];
					this.uploadPhase = "idle";
					this.uploadProgress = 0;
					this.model.file = null;
					if (this.$refs.form) this.$refs.form.classList.remove("was-validated");
					if (this.$refs.fileInput) this.$refs.fileInput.value = "";
					this.setFileValidity();
				},

				submitImport: function () {
					this.setFileValidity();
					if (!this.$refs.form.checkValidity()) {
						this.$refs.form.classList.add("was-validated");
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];
					this.isComplete = false;
					this.uploadPhase = "Upload";
					this.uploadProgress = 0;

					var formData = new FormData();
					formData.append("file", this.model.file);

					$.ajax({
						url: "/api/items/import",
						method: "POST",
						data: formData,
						processData: false,
						contentType: false,
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 600000
					})
						.done((response) => {
							if (response && response.success && response.data && response.data.jobId) {
								this.currentJobId = response.data.jobId;
								this.uploadProgress = 0;
								this.uploadPhase = "Queued";

								this.statusTimerId = null;
								var stopPolling = () => {
									if (this.statusTimerId) {
										clearInterval(this.statusTimerId);
										this.statusTimerId = null;
									}
									this.isSubmitting = false;
									this.uploadPhase = "Idle";
									this.uploadProgress = 100;
								};

								this.statusTimerId = setInterval(() => {
									$.getJSON(`/api/items/import/status/${response.data.jobId}`)
										.done((statusResponse) => {
											if (!statusResponse || !statusResponse.success)
												return;

											var serverPhase = String(statusResponse.data.phase || "");
											this.uploadPhase = serverPhase;

											var percent = Number(statusResponse.data.percent) || 0;
											this.uploadProgress = Math.max(0, Math.min(100, percent));

											if (serverPhase === "Completed") {
												stopPolling();
												this.isComplete = true;
											}
											else if (serverPhase === "Canceled") {
												this.resetAfterCancel("Upload canceled.");
											}
											else if (serverPhase === "Failed") {
												stopPolling();
												this.alertMessage = statusResponse.data.message || "Import failed.";
											}

											if (statusResponse.data.errors > 0) {
												this.alertErrors = [];
												this.alertErrors.push(`Processed: ${statusResponse.data.processed}`);
												this.alertErrors.push(`Errors: ${statusResponse.data.errors}`);
											}
										})
										.fail(() => { /* optional transient error handling */ });
								}, 700);
							} else {
								this.alertMessage = (response && response.message) || "Import failed.";
								this.alertErrors = ((response && response.data && response.data.errors) || [])
									.map(function (e) {
										return e.description || e;
									})
									.filter(Boolean);
								this.$refs.form.classList.add("was-validated");
								this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
								this.isSubmitting = false;
								this.uploadPhase = "Idle";
								this.uploadProgress = 0;
							}
						})
						.fail((jqXHR, status, err) => {
							if (status !== "abort") {
								console.error("AJAX error uploading CSV:", status, err);
								this.alertMessage = jqXHR && jqXHR.status === 404
									? "Endpoint not found (404)."
									: (status === "timeout" ? "Request timed out." : "Import failed.");
								this.$refs.form.classList.add("was-validated");
								this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
							}
							this.isSubmitting = false;
							this.uploadPhase = "Idle";
							this.uploadProgress = 0;
						});
				},
				onCancel: function () {
					if (!this.isSubmitting) {
						$(this.$el).closest(".modal").modal("hide");
						return;
					}

					this.isCanceling = true;

					if (this.uploadPhase === "Upload" && this.activeRequest && this.activeRequest.abort) {
						try {
							this.activeRequest.abort();
						} catch (_) { }
						this.resetAfterCancel("Upload canceled.");
						return;
					}

					var jobId = this.currentJobId;
					if (jobId) {
						$.post(`/api/items/import/cancel/${jobId}`)
							.always(() => {
								this.resetAfterCancel("Import canceled.");
							});
					} else {
						this.resetAfterCancel("Canceled.");
					}
				},

				resetAfterCancel: function (message) {
					if (this.statusTimerId) { clearInterval(this.statusTimerId); this.statusTimerId = null; }
					this.activeRequest = null;
					this.currentJobId = null;
					this.isSubmitting = false;
					this.isCanceling = false;
					this.uploadPhase = "Idle";
					this.uploadProgress = 0;
					this.isComplete = false;
					this.alertMessage = message || "";
				},
			},
			mounted: function () {
				$modal.off("show.bs.modal hidden.bs.modal");

				$modal.on("show.bs.modal", () => {
					if (!this.isSubmitting)
						this.clearState()
				});

				this.setFileValidity();
			}
		});
	}

	function open(onClose) {
		$modal.modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	return {
		init,
		open
	};

})(jQuery, Vue);

App.ItemImport.init();